import React, { useMemo } from "react";
import { renderGuidelineMarkdown } from "../../utils/guideline-markdown";

type GuidelineMarkdownProps = {
  markdown?: string | null;
  flat?: boolean;
  className?: string;
};

const GuidelineMarkdown: React.FC<GuidelineMarkdownProps> = ({
  markdown,
  flat = false,
  className = "",
}) => {
  const html = useMemo(
    () => renderGuidelineMarkdown(markdown ?? ""),
    [markdown]
  );

  if (!markdown?.trim()) {
    return null;
  }

  return (
    <div
      className={`guideline-prose prose prose-slate prose-sm max-w-none ${
        flat ? "guideline-prose--flat" : ""
      } ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default GuidelineMarkdown;
